document.addEventListener('DOMContentLoaded', () => {
  //change header color on mega menu hover
  document.querySelectorAll('.mega-menu').forEach(element => {
    element.addEventListener('mouseenter', () => {
      document.querySelector('.header-wrapper').classList.add('header-hover');
    });
  
    element.addEventListener('mouseleave', () => {
      document.querySelector('.header-wrapper').classList.remove('header-hover');
    });
  });  

  //change header color on scroll
  document.addEventListener("scroll", () => {
    checkScroll();
  });
  
  const checkScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const headerWrapper = document.querySelector(".header-wrapper");
  
    if (scrollTop > 80) {
      headerWrapper.classList.add("header-scroll");
      headerWrapper.classList.add("av");
    } else {
      headerWrapper.classList.remove("header-scroll");
    }
  };
  
  // Initial check in case the page is already scrolled past the threshold on load
  checkScroll();
  

  document.getElementById('close_menu-drawer').addEventListener('click', function() {
    document.querySelector('#Details-menu-drawer-container > summary.header__icon--menu').click();
  });
  
  document.querySelectorAll('.custom_accordion').forEach(accordion => {
    accordion.addEventListener('click', function () {
      this.classList.toggle('custom_accordion-active');
      const panel = this.nextElementSibling;
      panel.style.maxHeight = panel.style.maxHeight ? null : `${panel.scrollHeight}px`;
    });
  });   
});
